export default {
  termsAccept: "Slažem se sa {0}.",
  tos: "Opšti uslovi poslovanja",
  privacyAccept: "Slažem se sa {0}.",
  privacyPolicy: "Politika privatnosti",
  resetPassword: "Resetujte lozinku",
  usernamePasswordRequired: "Unesite korisničko ime i lozinku.",
  passwordTooShort: "Lozinka mora imati najmanje 8 znakova.",
  wrongCredentials: "Nije pronađen nijedan nalog sa navedenim podacima.",
  accountStructureItem: "Odeljenje",
  addRole: "Dodajte ulogu",
  allUserRelatedDeleteText:
    "Ovim se neopozivo brišu svi podaci relevantni za korisnike.",
  assignRoleModals: "Dodelite ulogu",
  canBeDownloadedText: "mogu se preuzeti pod dovršeno",
  changePassword: "Promenite lozinku",
  changingPasswordFor: "Promenite lozinku za korisnika",
  confirmDeleteText: "Unesite korisničko ime da potvrdite:",
  confirmDeteleBtnText: "Razumem, obrišite korisnika",
  confirmPassword: "Ponovite lozinku",
  createAccount: "Kreirajte nalog",
  createUser: "Kreirajte korisnika",
  currentPassword: "Važeća lozinka",
  customId: "Prilagođeni ID",
  dataPrivacyHeader: "Privatnost podataka",
  dataPrivacyText: "Tekst odeljka (sadržaj će uslediti)",
  dataPrivacyTitle: "Naslov odeljka",
  dataRelatedToMe: "Prikažite podatke sačuvane o meni",
  dataRelatedToMeTitle: "Sačuvani podaci",
  deleteText: "Da li ste sigurni da želite da izbrišete ovo",
  downloadDataRelaatedToMe: "Preuzmite sačuvane podatke",
  fileWithUserInformation: "Datoteka sa informacijama o korisniku",
  forgotPassword: "Zaboravili ste lozinku?",
  forgotPasswordText:
    "Unesite svoju adresu e-pošte da biste dobili link za resetovanje lozinke.",
  importUsers: "Importujte korisnike",
  newHere: "Novi ste ovde?",
  newPassowrd: "Nova lozinka",
  newPasswordShort: "Nova lozinka je suviše kratka",
  password: "Lozinka",
  passwordCantBeEmpty: "Lozinka ne može biti prazna",
  passwordsNotMatch: "Lozinke se ne poklapaju",
  pickUser: "Izaberite korisnika",
  pleaseFillUpAllFields: "Popunite sva polja",
  fieldIsRequired: "Polje {field} je obavezno",
  pleaseTypeNewPassword: "Unesite svoju novu lozinku",
  policyAcceptance: "Prihvatanje smernica",
  policyAcceptanceSave: "Prihvatanje",
  acceptPolicies: "Prihvatite smernice",
  profile: "Profil",
  role: "Uloga",
  roleExpiresOn: "Uloga ističe dana",
  saveDataAboutMe: "podaci sačuvani o meni",
  signIn: "Prijava",
  termsConditionsHeader: "Opšti uslovi poslovanja",
  termsConditionsText: "Tekst odeljka (sadržaj će uslediti)",
  termsConditionsTitle: "Naslov odeljka",
  typeInOne: "Unesite jedan za sve",
  username: "Naziv korisnika",
  firstname: "Ime",
  lastname: "Prezime",
  usernameMail: "Naziv korisnika ili adresa e-pošte",
  userNotes: "Beleške",
  userProfile: "Profil korisnika",
  userStatus: "Status korisnika",
  wrongCurrentPassword: "Pogrešna aktuelna lozinka",
  fillAllFields: "Molimo popunite sva obavezna polja",
  wrongUsernameOrPassword: "Naziv korisnika ili lozinka su pogrešni",
  minimumLength: "Minimalna dužina 8 znakova",
  atLeastOneBigAndSmall: "najmanje 1 malo i 1 veliko slovo",
  passwordNotEqualUsernameAndEmail:
    "Lozinka nije identična sa korisničkim imenom i adresom e-pošte",
  registrationKey: "Šifra za registraciju",
  registration: "Registracija",
  notAnEmailAdress: "Unesite ispravnu e-mail adresu.",
  company: "Firma",
  birthday: "Dan rođenja",
  birthdayHint: "Dan rođenja",
  birthyear: "Godina rođenja",
  accountName: "Naziv naloga",
  accountType: "Vrsta naloga",
  accountAddress: "Adresa vlasnika naloga",
  logo: "Logo",
  address: "Adresa",
  contry: "Država",
  zipCode: "Poštanski broj",
  lessThan: "manje od 1 mb",
  defaultLanguage: "Standardni jezik",
  accountStatus: "Status naloga",
  accountNotes: "Beleške o nalogu",
  createAccount: "Kreirajte nalog",
  updateAccount: "Ažurirajte nalog",
  fileToImport: "Beleške o nalogu",
  importStructure: "Importujte strukturu",
  addRootAccount: "Dodaj nalog na osnovnom nivou",
  usersPerMonth: "Mesečni korisnici",
  usersAdded: "Dodati korisnici",
  usersDeleted: "Obrisani korisnici",
  usersTotal: "Ukupno korisnika",
  city: "Grad",
  users: "Korisnik",
  coursesAvailable: "Dostupni kursevi",
  started: "Započet",
  completed: "Završen",
  openMandatoryAssignments: "Otvoreni obavezni zadaci",
  mandatoryAssignments: "Obavezni zadaci",
  dueMandatoryCompletions: "Dospele obavezne diplome",
  of: "od",
  accountOverview: "Pregled naloga",
  selectAccount: "Izaberite nalog",
  noAccountsAvailable: "Nema dostupnih naloga",
  completionRate: "Stepen završetka",
  averageResult: "Prosečan uspeh",
  courseOverview: "Pregled kurseva",
  reportCoursesSearchPlaceholder: "Potražite kurs",
  completedLastWeeks: "Završetak kurseva u poslednjih {number} nedelja",
  completedLastMonths: "Završetak kurseva u poslednjih {number} meseci",
  executionTime: "Distribucija prema vremenu izvršavanja (min)",
  completionLevel: "Distribucija prema bodovima završetka",
  knowledge: "ZNANJE",
  toolbox: "KUTIJA ZA ALAT",
  lessonCompleted: "Lekcija završena",
  lessonFailed: "Lekcija nije položena",
  repeatLesson: "Ponovite lekciju da biste nastavili",
  congratulations: "Čestitamo!",
  courseCompleted: "Kurs završen",
  percentCompleted: "Tačno ste odgovorili na $successRate% pitanje.",
  downloadCertificate:
    "Svoj sertifikat možete preuzeti u bilo kom trenutku pod „Sertifikati“ na profilu.",
  trueFalse: "Tačno ili pogrešno?",
  seconds: "Sek.",
  noChoiceText: "Šteta, prekasno.",
  right: "Tačno!",
  wrong: "Pogrešno",
  progress: "$trenutno od $ukupno",
  addCourseContent: "Dodajte sadržaje kursa",
  startCourseEditor: "Pokrenite editor kursa",
  addSemicolon: "Dodajte naslove odvojene tačkom i zarezom",
  addToProgram: "Dodajte u program",
  allAccounts: "Svi nalozi",
  certificate: "Sertifikat",
  certificates: "Sertifikati",
  completed: "Završen",
  contentIsLoaded: "Sadržaj je učitan",
  contentManager: "Menadžer sadržaja",
  courseCompleted: "Kurs završen",
  courseContent: "Sadržaj kursa",
  courseFormat: "Format kursa",
  coverPhoto: "Naslovna slika",
  editCoverPhoto: "Promenite naslovnu sliku",
  addCoverPhoto: "Dodajte naslovnu sliku",
  additionalDocuments: "Dodatna dokumentacija",
  editAdditionalDocuments: "Promenite dodatnu dokumentaciju",
  addAdditionalDocuments: "Dodajte dodatnu dokumentaciju",
  documents: "Dokumentacija",
  courseLables: "Etikete kurseva",
  courseLanguage: "Jezik kursa",
  courseNotes: "Beleške o kursu",
  courseStructure: "Struktura",
  courseTags: "Tagovi kursa",
  courseTitle: "Naziv kursa",
  createCourse: "Kreirajte kurs",
  curator: "POVERENIK",
  description: "Opis",
  details: "Detalji",
  dueDate: "Dospeva do",
  duration: "Trajanje",
  exportStatistics: "Eksportujte statistike",
  learningStandard: "Standard učenja",
  licenses: "Licence",
  mandatory: "Obavezan kurs",
  noAssessment: "Trenutno nema dostupnih recenzija.",
  noCoursesAssigned: "Nema kurseva povezanih sa vašim nalogom. Posetite ",
  noCoursesAvailable: "Trenutno nema dostupnih kurseva.",
  noDueDate: "Nema datuma dospeća",
  overview: "Pregled",
  page: "",
  pickAnAccount: "Izaberite nalog",
  printCertificate: "Štampajte sertifikat",
  publishCourse: "Objavite kurs",
  publishedToAccount: "Objavljeno u nalogu",
  relatedCourses: "Slični kursevi",
  remove: "Uklonite",
  removeFromProgram: "Uklonite iz programa",
  singleAccount: "Pojedinačan nalog",
  startCourse: "Počnite",
  successMessageOne: "Čestitamo, uspešno ste ",
  successMessageThree:
    "Sada možete preuzeti ili odštampati svoj sertifikat o završetku. ",
  successMessageTwo: " završili kurs!",
  tags: "Odrednice",
  unpublishCourse: "Poništite objave",
  updateCourseContent: "Učitajte sadržaj kursa",
  updateCourse: "Ažurirajte kurs",
  youDidntfinishCourse: "Još niste završili kurs.",
  courseVisibleFor: "Kurs je vidljiv za",
  accountStructureItem: "Odeljenje",
  courseAssigmentOptions: "Opcije zadatka",
  assignCourse: "Dodelite kurs",
  pickACourse: "Izaberite jedan kurs",
  noDocumentsAvailable: "Nema dokumentacije",
  nothingRelated: "Nema sličnih kurseva",
  nothingWritten: "ništa nije uneseno",
  noTagsAvailable: "Nema odrednica",
  alreadyGlobal: "Kurs je već objavljen širom sveta.",
  questionsanswered: "Pitanja",
  completedOn: "Završen dana",
  locale: "de-DE",
  quizAuthorizationContent: "Autorizacija kviza",
  courseNotPublished: "Kurs trenutno nije objavljen",
  courseNotPublishedForAccount:
    "Kurs trenutno nije objavljen za nalog $account",
  clickToPublishCourse: "Objavite kurs",
  visible: "Vidljivo",
  userIsNotContentManager:
    "Niste menadžer sadržaja i stoga ne možete uređivati sadržaj kursa.",
  assignmentOpen: "Otvoren",
  assignmentStarted: "Započet",
  assignmentCompleted: "Završen",
  dueDatePassed: "Prekoračen datum dospeća",
  exitCourse: "Prekinite kurs",
  markAsFinished: "Kurs završen",
  assignToAllUsers: "Kurs je dodeljen svim korisnicima u nalogu",

  learningPoints: "Tačke učenja",
  learningPointsAbbreviation: "TU",
  back: "Nazad",
  next: "Dalje",
  responsesMissing: "Popunite sve stavke pre nego što nastavite",

  configureLogging: "Konfigurišite vođenje evidencije",
  createAccount: "Registrujte se",
  changeAccount: "Promenite nalog",
  deleteAccount: "Obrišite nalog",
  importAccountStructure: "Importujte strukturu naloga",
  createUser: "Kreirajte korisnika",
  importUser: "Importujte korisnike",
  changeUser: "Promenite korisnika",
  deleteUser: "Obrišite korisnika",
  assignUserRole: "Dodelite ulogu",
  resetPassword: "Resetujte lozinku",
  createCourse: "Kreirajte kurs",
  changeCourse: "Promenite kurs",
  addQuizContent: "Dodajte sadržaje kviza",
  changeQuizContent: "Promenite sadržaj kviza",
  addContent: "Dodajte sadržaj kursa",
  changeContent: "Promenite sadržaj kursa",
  deleteCourse: "Obrišite kurs",
  deleteContent: "Obrišite sadržaj kursa",
  publishCourse: "Objavite kurs",
  unpublishCourse: "Poništite objave",
  assignCourse: "Dodelite kurs",
  unassignCourse: "Poništite dodelu kursa",
  systemMessages: "Sistemske poruke",
  learningManagement: "Upravljanje učenjem",
  courseManagement: "Upravljanje kursom",
  userManagement: "Upravljanje korisnicima",
  organizationStructure: "Organizaciona struktura",
  accountManagement: "Upravljanje nalozima",
  system: "Sistem",
  learningManagementDetail: "Planovi učenja i predmetni zadatak",
  courseManagementDetail: "Upravljajte sadržajima kursa",
  userManagementDetail: "Upravljajte korisnicima i resetujte lozinke",
  organizationStructureDetail: "Definišite organizacionu strukturu",
  accountManagementDetail: "Upravljajte nalozima",
  systemDetail: "Sistemske evidencije i podešavanja",
  userCreateSuccess: "Korisnik uspešno kreiran",
  createOtherUser: "Dodajte još jednog korisnika",
  backToUserOverview: "Nazad na pregled korisnika",
  importMoreUsers: "Importujte ostale korisnike",
  currentRoles: "Važeće uloge",
  numberOfRoles: "Broj uloga",
  numberOfUsers: "Korisnik",
  deleteAccountMessage:
    "Molimo da potvrdite da ste nalog '$account' löschen wollen.",
  showStatistics: "Prikažite statistike",
  appendAccount: "Dodajte nalog na $account.",
  courseAssignments: "Dodeljeno",
  courseAssignmentsForCourse: "Zadaci kursa za $course",
  mandatoryAssignments: "Dodela obaveznih kurseva",
  dueDateAssignments: "Sa rokom",
  dueDatePassed: "Dospeva",
  userOrAccount: "Korisnik ili odeljenje",
  expiryDate: "Datum isteka",
  deletePublication: "Obrišite objave",
  deletePublicationMessage:
    "Da li ste sigurni da želite da izbrišete objavu za nalog $account?",
  orgStructure: "Odeljenje",
  type: "Tip",
  downloadTemplate: "Preuzmite šablon",
  published: "Objavljeno",
  scorm: "SCORM",
  quiz: "Kviz",
  staticFile: "PDF",
  editPublication: "Obradite objave",
  pleaseDefineCourseContent:
    "Molimo definišite sadržaj kursa pre nego što ga objavite.",
  usernameMissing: "Nedostaje naziv korisnika",
  usernameError: "Korisničko ime može da sadrži samo alfanumeričke znakove",
  emailMissing: "Nedostaje adresa e-pošte",
  emailError: "Nema validne adrese e-pošte",
  passwordMissing: "Nedostaje lozinka",
  passwordError:
    "Lozinka mora imati najmanje 8 znakova, kao i jedno veliko i jedno malo slovo.",
  registrationKeyManagement: "Šifra za registraciju",
  registrationKeyManagementDetail: "Upravljanje šiframa za registraciju",
  addRegistrationKey: "Dodajte šifru za registraciju",
  registrationLink: "Link za registraciju",
  createKey: "Dodajte",
  user_upload_maximum: "Do 1000 korisnika po učitavanju",
  userState: "Status korisnika",
  userStateDetail: "Zugangsberechtigung und Pflichtkurse.",
  testsPassed: "Test završen",
  access: "Pristup",
  downloadReport: "Preuzmite izveštaj",
  success: "Uspešno sačuvano!",
  warning: "Oprez!",
  error: "Greška!",
  removedFromProgram: "Kurs je uklonjen iz vašeg programa",
  addedToProgram: "Kurs je dodat u vaš program",
  courseCreated: "Kurs je kreiran",
  courseNotCreated: "Kurs nije kreiran",
  fillUpFields: "Popunite sva obavezna polja",
  cookieNotAvailable: "Vaša sesija više nije važeća, prijavite se ponovo",
  courseNotFinished: "Nema dostupnih informacija o završetku kursa",
  courseAborted: "Kurs je prekinut",
  correctAnswer: "Tačan odgovor",
  wrongAnswer: "Pogrešan odgovor",
  courseStarted: "Kurs je započeo",
  testFailed: "Niste položili test",
  courseCompleted: "Uspešno ste završili kurs",
  imageTooLarge: "Datoteka treba da bude manja od 2 MB",
  wrongFormat: "Pogrešan format",
  passwordReset:
    "Link za resetovanje lozinke je poslat na navedenu adresu e-pošte",
  passwordChanged: "Lozinka je promenjena",
  accountAdded: "Dodat je nalog",
  accountUpdated: "Nalog je ažuriran",
  accountDeleted: "Nalog je obrisan",
  userImported: "Korisnik je importovan",
  userNotImported: "Korisnik nije importovan",
  loggingConfigSaved: "Konfiguracija za ulogovanje je sačuvana",
  userDeleted: "Korisnik je obrisan",
  userAdded: "Korisnik je kreiran",
  userUpdated: "Korisnik je ažuriran",
  GDPRLoaded: "GDPR je učitan",
  cookiesDisabled: "Deaktivirali ste kolačiće",
  wrongCredentials: "Pogrešni podaci za prijavu",
  fileUploaded: "Vaša datoteka je učitana",
  courseContentUpdated: "Sadržaj kursa je ažuriran",
  coursePublished: "Kurs je objavljen",
  courseUnPublished: "Kurs nije objavljen.",
  serverUnreachable: "Server nije dostupan",
  courseContentAdded: "Sadržaj kursa je uspešno dodat.",
  user_upload_exceeded:
    "Previše korisnika. Podržano je najviše 1000 korisnika po otpremanju.",
  selectAccounts: "Odaberite nalog",
  selectAccountToContinue: "Izaberite nalog da biste nastavili",
  accountOverview: "Pregled naloga",
  users: "Korisnik",
  courses: "Kursevi",
  coursesCompleted: "Završeni kursevi",
  completedCoursesPerUser: "Završeni kursevi po korisniku",
  learningHours: "Sati učenja",
  learningHoursPerUser: "Sati učenja po korisniku",
  courseOverview: "Pregled kursa",
  completed: "Završen",
  assigned: "Dodeljen",
  courseDetails: "Detalji",
  selectCourse: "Odaberite kurs",
  details: "Odaberite",
  type: "Tip",
  dueDate: "Do",
  mandatory: "Obavezan kurs",
  completionRate: "Stepen završetka",
  averageScore: "Rezultat testa",
  duration: "Trajanje",
  averageDuration: "Prosečno trajanje",
  account: "Nalog",
  accountName: "Naziv naloga",
  accounts: "Nalozi",
  active: "Aktivan",
  admin: "Administrator",
  all: "Svi",
  not_found: "Stranica ne postoji",
  assessmentStatistics: "Statistika rejtinga",
  assignedUsersOnly: "Samo dodeljeni korisnici",
  autoIndividual: "Automatski, individualno",
  cancel: "Prekinite",
  cardImage: "Slika na kartici",
  close: "Zatvorite",
  completed: "Završen",
  confirm: "Potvrdite",
  country: "Zemlja",
  course: "Kursevi",
  courseDescription: "Opis kursa",
  courseDocuments: "Dokumentacija kursa",
  courses: "Biblioteka",
  courseStructure: "Struktura kursa",
  dataProtection: "Politika privatnosti",
  defaultLanguage: "Standardni jezik",
  deleteText: "Da li ste sigurni da želite da obrišete ovo",
  delete: "Obrišite",
  details: "Detalji",
  dragAndDrop: "Prevucite i otpustite / kliknite da biste dodali",
  dueDate: "Dospeva dana",
  email: "E-pošta",
  empty: "Prazno",
  exit: "Odjavite se",
  expiresOn: "Ističe dana",
  fileImport: "Datoteka za importovanje",
  image: "Slika",
  inactive: "Neaktivno",
  language: "Jezik",
  logo: "Logo",
  mandatory: "Obavezan kurs",
  monthsLabels: [
    "Januar",
    "Februar",
    "Mart",
    "April",
    "Maj",
    "Jun",
    "Jul",
    "Avgust",
    "Septembar",
    "Oktobar",
    "Novembar",
    "Decembar",
  ],
  myAccount: "Moj nalog",
  myProfile: "Moj profil",
  myProgram: "Moj program",
  myRoles: "Moje uloge",
  never: "Nikada",
  no: "Ne",
  none: "Nema",
  notFound: "Nije pronađeno",
  phoneNumber: "Broj telefona",
  playImage: "Reprodukujte sliku",
  publishingExpiresOn: "Objava ističe dana",
  publishTo: "Objavljeno u",
  reports: "Izveštaj",
  save: "Sačuvajte",
  search: "Traži...",
  status: "Status",
  structureItem: "Odeljenje",
  termsAndConditions: "Uslovi poslovanja",
  unlimited: "Neograničeno",
  update: "Ažurirajte",
  user: "Korisnik",
  username: "Naziv korisnika",
  users: "Korisnik",
  visibility: "Vidljivost naloga",
  yes: "Da",
  zipCode: "Poštanski broj",
  info: "Informacije",
  error: "Greška",
  alert: "Alarm",
  criticalAlert: "Kritičan alarm",
  navigation: "Navigacija",
  note: "Napomena",
  userProfile: "Profil korisnika",
  userId: "ID korisnika",
  customId: "ID",
  organizationalStructure: "Organizaciona struktura",
  created: "Kreirano dana",
  new: "Novo",
  noResults: "Nema rezultata",
  noData: "Nema podataka",
  uploadFile: "Učitajte datoteku",
  id: "ID",
  name: "Naziv",
  append: "Dodajte",
  edit: "Obradite",
  format: "Format",
  years: "Godina | Godine",
  months: "Mesec | Meseci",
  weeks: "Nedelja | Nedelje",
  days: "Dan | Dani",
  seconds: "Sekunda | Sekunde",
  minutes: "Minuta | Minute",
  hours: "Sat | Sati",
  date: "Datum",
  message: "Poruka",
  fax: "Telefaks",
  genericError:
    "Došlo je do greške, pokušajte ponovo da učitate stranicu. Ako greška i dalje postoji, kontaktirajte administratora sistema.",
  action: "Akcija",

  // TODO
  roles: "Uloge",
  properties: "Svojstva",
  property: "Svojstvo",
  assignUserProperty: "Dodelite svojstvo",
  userProperties: "Svojstva korisnika",
  addTagToUser: "Dodelite svojstvo",
  showMoreFilters: "Prikažite više filtera",
  assigned: "Dodeljen",
  unassigned: "Nije dodeljen",
  assignedOrUnassigned: "Dodeljen / Nije dodeljen",
  emailAboutChange: "Pošaljite obaveštenje putem e-pošte",
  showLessFilters: "Sakrijte filtere",
  clearFilters: "Uklonite filtere",
  no_changes_assignment_button: "Nema promena",
  assignment: "Zadaci",

  upload_picture: "Učitavanje",
  take_picture: "Snimanje",
  access_card: "Pristipna karta",

  assign_course: "Dodelite kurs",
  add_assignment_to_users: "dodelite $users",
  remove_assignments_from_users: "uklonite iz $users dodele",
  update_assignments_for_users: "ažurirajte za $users dodelu",
  create_property: 'Kreirajte svojstvo "$property"',
  non_mandatory: "Nije obavezan kurs",
  department: "Odeljenje",
  user_details: "Korisnički podaci",
  download_file: "Preuzmite datoteku",
  your_browser_not_support_this_content:
    "Vaš pretraživač ne podržava ovaj format datoteke.",
  browser_not_support_pdf:
    "Your browser can't display pdf files. Scroll down to download the pdf instead.",
  upload_file: "Učitajte datoteku",
  deleteDocument: "Obrišite dokument",
  deleteDocumentConfirmation: "Da li ste sigurni da želite obrisati $document?",
  video_unsupported: "Ovaj pretraživač ne podržava HTML5 video.",
  confirm: "Potvrdite",
  confirmed: "Potvrđeno",
  multiselect: "Dozvolite izbor više svojstava",
  profile_image: "Profilbild",
  property_type: "Eigenschaften Typ",
  account_details: "Account details",
  remove_assigned_properties: "Zugewiesene Eigenschaften entfernen",
  mandatory_user_properties: "Obligatorische Benutzereigenschaften",

  select_property_first: "Izaberite svojstvo da biste nastavili.",
  selected_property_already_mandatory: "Izabrano svojstvo je već obavezno.",
  confirm_remove_assigned_properties:
    "Bitte bestätigen sie dass sie alle zugewiesenen Eigenschaften des typs $type entfernen wollen, dieser Schritt kann nicht rückgangig gemacht werden.  .",
  tags_removed_from_users:
    "Alle zugewiesenen Eigenschaften des Typs $type wurden entfernt.",
  add_mandatory_user_property:
    "Bitte wählen sie folgende Merkmale für ihre Tätigkeit aus:",

  upload_certificate: "Zertifikat hochladen",
  delete_certificate: "Zertifikat löschen",
  confirm_delete_certificate:
    "Sind sie sicher, dass sie das Zertifikat $certificateName löschen wollen?",

  certificateName: "Naziv sertifikata",
  issuedFrom: "Izdao",
  ectsPoints: "ECTS bodova",
  ects: "ECTS",

  completedInPercent: "Ispunjeno u procentima",

  issuedAt: "Izdato dana",
  receivedAt: "Primljeno dana",
  validUntil: "Važi do",
  unlimitedValidity: "Neograničeno važenje",

  uploadedCertificates: "Učitani sertifikati",

  drag_drop_steps:
    "Koristite prevlačenje i ispuštanje da biste umetnuli stavke iz leve kolone.",
  add_lesson: "Dodajte lekciju",

  minCompletion: "Procenat poena za polaganje lekcije",
  randomStepOrder: "Nasumični redosled pojedinačnih koraka.",
  fixedViewExecutionOrder: "Nasumični redosled pojedinačnih pogleda.",
  allowBackNavigation: "Dozvolite obrnutu navigaciju",
  maxTimeForCompletions: "Maksimalno vreme za završetak lekcije u minutima",
  maxRetries: "Maksimalan broj ponavljanja",
  maxNumberOfCompletions:
    "Maksimalan broj ponavljanja za poboljšanje rezultata",

  quiz: "Kviz",
  text: "Tekst",
  multimedia: "Video",
  pdf: "Pdf",
  inputText: "Unos teksta",
  inputDate: "Unos datuma",

  quiz_description:
    "Postavite korisniku pitanje i pustite ga da izabere jedan od nekoliko mogućih odgovora",
  text_description:
    "Prikažite korisniku tekst i opciono mu dozvolite da potvrdi sadržaj teksta.",
  multimedia_description:
    "Prikažite korisniku video i opciono mu dozvolite da potvrdi sadržaj videa.",
  pdf_description:
    "Pokažite korisniku PDF i opciono mu dozvolite da potvrdi sadržaj.",
  inputText_description: "Neka korisnik unese tekst.",
  inputDate_description: "Neka korisnik unese datum.",

  lessons: "Lekcije",
  new_lesson: "Nova lekcija",

  settings: "Podešavanja",
  requiresCompletion:
    "Korak mora biti završen da biste nastavili sa radom na kursu",
  requiresInteraction: "Korisnik mora da potvrdi ovaj korak",
  isEditable: "Korisnik može naknadno da uredi ovaj korak",
  points: "Bodovi",
  clickToEdit: "(kliknite za obradu)",
  choiceSettings: "Podešavanja odgovora",
  choice: "Antwort",
  choiceText: "Odgovor $index tekst",
  choiceExplanation: "Odgovor $index objašnjenje",
  choiceIsCorrect: "Tačan odgovor",
  addChoice: "Dodajte odgovor",
  deleteChoice: "Obrišite odgovor",
  uploadVideoFile: "Učitajte video datoteku",
  discardChanges: "Odbacite promene",
  addInputLabel: "(dodajte oznaku)",
  inputType: "Vrsta unosa",
  week: "Nedelja",
  month: "Mesec",
  year: "Godina",
  label: "Oznaka",
  minDate: "Minimalan datum",
  maxDate: "Maksimalan datum",
  oneLine: "Jedan red",
  rows: "Redovi",
  multipleLine: "Više redova",
  minLength: "Minimalna dužina",
  maxLength: "Maksimalna dužina",
  showWordLimit: "Prikažite maksimalan broj znakova",

  lessonFailedNoMoreRetries: "Nakon $retries pokušaja, niste položili kurs.",
  lessonFailedMoreRetries:
    "Imate još $retries pokušaja da položite ovu lekciju i kurs.",
  lessonFailedOneMoreRetries:
    "Imate još jedan pokušaj da položite ovu lekciju i kurs.",
  registrationKeyAlphanumeric:
    "Šifra za registraciju (alfanumerička, min. 10 znakova)",
  registrationKey10Letters:
    "Šifra za registraciju mora imati najmanje 10 znakova.",
  chooseAnAccountToContinue: "Izaberite nalog da biste nastavili.",

  help: "Pomoć",
  alreadyRegistered: "Već ste registrovani",
  additionalDetails: "Dodatni podaci",
  additionalDetailsSave: "Potvrdite",
  upload: "Učitavanje",
  uploadVideo: "Učitajte video",
  uploadPdf: "Učitajte Pdf",
  step: "Korak",
  flexView: "Pogled",
  flexViews: "Pogledi",
  lesson: "Lekcije",
  dragInThisAreaToDelete:
    "Prebacite elemente u ovu oblast, da biste ih izbrisali",
  editor: "Editor",
  baseLanguage: "Izvorni jezik",
  translation: "Prevod",
  editCourse: "Obradite kurs",
  editTranslation: "Obradite prevod",

  pointTracking: "Prikažite bodove",
  repeatable: "Može da se ponovi",
  completionShowScore: "Prikažite ukupan broj bodova",
  dragAndDropCertificate:
    "Prevucite i ispustite PDF datoteku ili kliknite da biste je dodali",
  fileName: "Naziv datoteke",
  fileSize: "Veličina datoteke",
  userProfileV2: "Profil korisnika v2",
  certification: "Sertifikati",
  logs: "Logo",
  issuedBy: "Izdao",
  issuedOn: "Izdato dana",
  fulfilledInPercent: "Ispunjeno u procentima",
  plusNewTag: "+ Novi tag",
  orSeparator: "Ili",
  contentManagerPicker: "Menadžer sadržaja",
  saveChangesTitle: "Sačuvajte promene",
  saveChangesBody:
    "Imate nesačuvane promene.\nŽelite li da ih sačuvate ili odbacite?",
  flexLessonLocked: "Korisnik mora da završi lekciju, da bi mogao da nastavi.",
  flexSubset: "Broj pregleda iz ove lekcije koje korisnik mora da obradi.",

  curatorName: "Ime i prezime tutora",
  curatorCompany: "Kompanija tutora",
  curatorDescription: "Opis tutora",
  courseCompletedTitle: "Kurs završen, naslov",
  courseCompletedSubtitle: "Kurs završen, podnaslov",
  courseCompletedNote: "Kurs završen, tekst",
  completionShowScore: "Prikažite bodove nakon završetka kursa",
  failedCourseInformation: "Prikaz teksta ako kurs nije položen",
  pinPage: "Uvek pokažite prikaz na početku ili na kraju lekcije",
  start: "Početak",
  end: "Kraj",
  courseDuration: "Trajanje kursa u minutima",
  randomizeAnswers: "Promešajte odgovore",
  closeEditor: "Zatvorite editor",
  courseNotEditable:
    "Ovaj kurs je već u upotrebi i stoga se ne može uređivati.",
  flex: "Fleks",
  copied: "Kopirano u privremenu memoriju",
  covidCertificates: "Sertifikati o vakcinaciji",
  covidCertificatesDetail:
    "Upravljanje sertifikatima o vakcinaciji i testiranju",
  covidInstructions: "Relevantna uputstva za COVID-19",
  covid: "COVID-19",
  addCertificate: "Zertifikat hinzufügen",
  scanQrCode: "Skenirajte QR kod",
  scanQrCodeDescription:
    "Sledeći QR kodovi se mogu skenirati ili učitati: Potvrde o vakcinaciji, sertifikati o PCR i antigen testovima, sertifikati o oporavku od infekcije",
  openFile: "Datei öffnen",
  openImage: "Bilddatei öffnen",
  validFrom: "Gueltig seit $date",
  validFor: "Gueltig am $date",
  vaccinationCertificatesValid:
    "Vaši sertifikati su u skladu sa navedenim pravilima",
  vaccinationCertificatesInvalid:
    "Vaši sertifikati nisu u skladu sa navedenim pravilima",
  certificateInvalid: "Ovaj sertifikat je nevažeći",
  certificateExpired: "Ovaj sertifikat je istekao",
  updatedOn: "Ažuriran $date",
  uploadinCertificate: "Učitajte sertifikat",
  certificateUploadError: "Greška prilikom učitavanja sertifikata",
  certificateNameMismatch: "Sertifikat je izdat na drugo ime.",
  certificateBirthdayMismatch: "Sertifikat je izdat na drugi datum rođenja.",
  certificateExists: "Sertifikat već postoji.",
  certificateUploaded: "Sertifikat uspešno učitan",
  instructions: "Uputstva",
  accessRules: "Pravila pristupa",
  selectAccessRule: "Odaberite pravila pristupa",
  qrCode: "QR kod",
  certificateDeleted: "Sertifikat uklonjen",
  deleteCertificateConfirmation:
    "Da li ste sigurni da želite da uklonite ovaj sertifikat?",
  event: "Događaj",

  instructions: "Uputstva",
  isOnlineEvent: "Onlajn događaji",
  eventLink: "Link za događaj",
  eventLocation: "Mesto",
  selfRegistration: "Samoregistrovanje",
  attendanceConfirmation: "Prisustvo",
  passedConfirmation: "Položio/la",
  mark: "Ocenjen",
  trainer: "Trener",
  attendanceAndGrades: "Prisustvo i ocenjivanje",
  onlyIfMandatoryCourse: "Kod obaveznih zadataka",
  allUsersInAccount: "Svi korisnici naloga",
  dateManagement: "Upravljanje terminima",
  dateManagementDetail: "Upravljanje terminima i rezultatima učešća",
  courseFilter: "Filter kursa",

  fromTo: "Od - do",
  capacity: "Kapacitet",
  unlimitedCapacity: "Neograničen kapacitet",
  invalidatePreregistration: "Istek predregistracije",
  allowPreregistration: "Dozvolite predregistraciju",
  newDate: "Novi termin",
  editDate: "Obradite termin",
  preenrollments: "Predregistracija",
  enrollments: "Prijave",
  preregistrationDate: "Predregistracija $date",
  registered: "Registrovano",
  notRegistered: "Nije registrovano",
  registeredAndNotRegistered: "Registrovano / Nije registrovano",
  selectCourseToContinue: "Odaberite kurs, da biste nastavili",
  changesSavedSuccessfully: "Promene uspešno sačuvane",
  cancelRegistrationTitle: "Odjava",
  cancelRegistrationBody:
    "Da li zaista želite odjaviti $name sa sledećeg termina?",
  date: "Termin",
  dates: "Termini",
  unregister: "Odjavite se",
  changeRegistrationTitle: "Preregistracija",
  currentRegistration: "$name je već registrovan za sledeći termin",
  changeRegistrationBody:
    "Da li želite da otkažete postojeću prijavu i napravite novu za sledeći termin?",
  preregistrationAvailableRegistrations: "Predregistracija / Slobodna mesta",
  seatsLeft: "Slobodna mesta",
  registrationTitle: "Prijava",
  registrationBody:
    "Prijavom za sledeći datum, kurs $course će biti dodeljen korisniku kao obavezan kurs.",
  register: "Prijava",
  myDates: "Moji termini",
  dateDetails: "Detalji termina",
  attendees: "Učesnik",
  fractionOfTotal: "$fraction od $total",
  registrations: "Registracije",
  link: "Link",
  notPassed: "Nije položeno",
  passed: "Položio/la",
  attended: "Učestvovao/la",
  notAttended: "Nije učestvovao/la",
  youAreRegisteredFor: "Prijavljeni ste za sledeći termin:",
  unlimitedSeats: "Nema ograničenja mesta",
  otherDates: "Ostali termini",
  managerWillAssignDate:
    "Oni su prijavljeni za termin od strane njihovog menadžera.",
  covidInstructionsLabel: "Uputstva na sistemskom jeziku $lang.",
  cameraNotAllowedError:
    "Odbijeno je korišćenje kamere. Ponovo učitajte stranicu ili promenite pristup kameri u podešavanjima pretraživača.",
  cameraNotFoundError:
    "Nije pronađena kamera. Umesto toga koristite učitavanje.",
  cameraNotReadableError:
    "Nije bilo moguće pristupiti kameri. Uverite se da nijedan drugi program ne koristi kameru.",
  cameraNotAvailable:
    "Vaš pretraživač ne podržava pristup kameri. Umesto toga koristite učitavanje.",
  qrCodeUploadError:
    "QR kod nije mogao biti pročitan. Uverite se da na slici postoji samo jedan QR kod i povećajte rezoluciju ako je potrebno.",
  confirmCovidRulesManuallyTitle: "COVID-19 - Vizuelna kontrola statusa",
  confirmCovidRulesBody:
    "Ovim potvrđujem da su dokazi koje je pokazao $user u skladu sa trenutnom regulativom o COVID-19 i da su važeći za danas.",

  activateApis: "Aktivirajte API sektor",
  allowApiManagement: "Dozvolite API upravljanje",
  allowedApis: "Otključani API",
  volume: "Obim u req/day",
  throttle: "Throttle in req/min",
  apis: "APIs",
  apisDetail: "Upravljanje API šiframa",

  keys: "Šifra",
  key: "Šifra",
  keyName: "Naziv",
  keyPurpose: "Svrha",
  createApiKey: "Dodajte šifru",
  keyCopiedToClipboard: "Šifra je kopirana u privremenu memoriju.",
  deleteKey: "Obrišite šifru",
  deleteKeyMessage:
    "Sind sie sicher, dass sie den Schlüssel '$name' für '$purpose' löschen wollen?",
  changeKey: "Schlüssel bearbeiten",
  keyCreatedSuccessfully: "Dodata je Api šifra",
  keyUpdatedSuccessfully: "Promene uspešno sačuvane",
  api: "Api",
  addApi: "Dodajte Api",
  editApi: "Obradite Api",
  example: "Primer",
  apiDetails: "Api detalji",
  flex: "Fleks",
  notAvailable: "Nije dostupno",
  method: "Metoda",
  requestBody: "Zahtev",
  responses: "Odgovori",
  parameters: "Parametri",
  manualCheck: "Kontrola dokaza",
  isOnline: "Onlajn",
  removingDependantCourseNotAllowed:
    "Brisanje kursa koji je deo programa nije dozvoljeno. Prvo uklonite kurs iz programa.",
  passwordResetSent: "E-mail poslat",
  passwordResetSentText:
    "Link za resetovanje lozinke je poslat na {email}.\n\nMolimo proverite svoj inbox - uključujući folder za spam ili neželjenu poštu.",
  backToLogin: "Nazad na prijavu",
  billingAddress: "Adresa za naplatu",
  fieldsAreMissing: "Sledeća polja su obavezna: {fields}",
  fixErrorsBeforeSaving: "Ispravite sledeće pre čuvanja:",
};
